module.exports = __webpack_public_path__ + "img/cxample_12.8cd5f80f.png";